import axios from 'axios';
import languageUtils from '$common/utils/language';
import storage from '$common/utils/storage';
import MD5 from 'md5.js';

const createSign = Symbol('createSign');
const queryString = Symbol('queryString');
const getMathRandom = Symbol('getMathRandom');
const setLang = Symbol('setLang');

export default class Curl {
  /**
   * 构造函数
   * 对应初始化 headers 参数
   * https://wiki.kh-super.net/pages/viewpage.action?pageId=2556963
   * @param {*} constructorParams
   */
  constructor(constructorParams = {}) {
    const {
      language,
      TermTyp = 'H5',
      deviceId,
      signVer = '1.0',
      appVersion = '2.8.0',
      channel = 'H5',
      appId = 'SuperApp',
      projectName = 'SuperApp',
      osVersion = 'h5',
      phoneModel,
      randomLength = 8
    } = constructorParams;
    this.randomLength = randomLength;
    this.axios = axios;
    this.osVersion = osVersion;
    this.language = language || languageUtils.getPageHeaderCurrentLanguage;
    this.TermTyp = TermTyp;
    this.deviceId = storage.getItem('device-id') || deviceId || `${new Date().valueOf()}-${this[getMathRandom]().toString()}`;
    storage.setItem('device-id', this.deviceId);
    this.signVer = signVer;
    this.appVersion = (window.ssrConfig && typeof window.ssrConfig === 'object' && window.ssrConfig.routerConfig && window.ssrConfig.routerConfig.appVersion) || appVersion;
    this.channel = channel;
    this.appId = appId;
    this.projectName = projectName;
    this.phoneModel = phoneModel || navigator.userAgent;
    this.requestTm = ((date = new Date()) => new Date(date - date.getTimezoneOffset() * 6e4).toJSON().substr(0, 19).replace(/-|T|:/g, ''))(new Date()) + this[getMathRandom]().toString();
  }
  isObject = obj => typeof obj === 'object' && obj !== null;
  /**
   * 递归转换 JSON 为 key=value&key={key=valu&key=value}&key=[{key=value},{key=value}] 格式
   * @param { POST 访问时的 data } body
   */
  [queryString](body) {
    let result = body
    if (typeof body === 'object') {
      if (Array.isArray(body)) {
        result = body
          .map(e => {
            const ret = this.isObject(e)
              ? encodeURIComponent(this[queryString](e))
              : encodeURIComponent(e)
            return ret
          })
          .join(',')
        result = '[' + result + ']'
      } else {
        const keys = Object.keys(body).sort()
        let query = ''
        keys.forEach(key => {
          const symbol = query ? '&' : ''
          query += `${symbol}${key}=${(this.isObject(body[key]) &&
            encodeURIComponent(this[queryString](body[key]))) ||
            encodeURIComponent(body[key])}`
        })
        result = '{' + query + '}'
      }
    }

    const decodeResult = decodeURIComponent(result)
    // let decodeResult = decodeURIComponent(result).replace(/\\|\"/g, '')
    return decodeResult
  }
  /**
   * 生成对应长度的随机数
   * @param { 随机数长度 } __langth
   */
  [getMathRandom]() {
    let maxLengthNum = '1';
    const __langth = (this.randomLength - 0) || 1;
    for (let i = 0; i < __langth; i++) {
      maxLengthNum += '0';
    }
    const str = parseInt(Math.random() * ((maxLengthNum - 0) || 1), 10).toString();
    return str.length === __langth && str || this[getMathRandom]();
  }
  /**
   * 生成对应算法, 基础算法方式，需要 Symbol 隐藏
   * @param {*} body
   */
  [createSign](body) {
    const paramsStr = this[queryString](Object.assign({}, {
      requestTm: this.requestTm,
      deviceId: this.deviceId
    }, body));
    window.location.href.indexOf('show-console') !== -1 && console.log('原文：', paramsStr);
    return new MD5().update(paramsStr.substring(1, paramsStr.length - 1)).digest('hex');
  }
  /**
   * 通过请求拦截器注入语言
   * @param {*}} curl
   */
  [setLang](curl) {
    // 请求拦截器
    curl.interceptors.request.use(config => {
      config.headers['Accept-Language'] = this.language;
      config.headers.language = this.language;
      return config;
    }, error => Promise.reject(error));
  }
  getCurl(body) {
    const curl = axios.create({
      headers: {
        'Content-Type': 'application/json',
        TermTyp: this.TermTyp,
        requestTm: this.requestTm,
        deviceId: this.deviceId,
        appId: this.appId,
        signVer: this.signVer,
        sign: this[createSign](body),
        appVersion: this.appVersion,
        channel: this.channel,
        projectName: this.projectName,
        phoneModel: this.phoneModel,
        osVersion: this.osVersion
      },
      crossDomain: true,
      //  10 秒超时
      timeout: 10e4
    });
    this[setLang](curl);
    return curl;
  }
}
